import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_DISMISS_TEXT = 'Close';

/*
Props:
  - onDismiss: () => {}
Usage:
  In JSX: <Alert ref={c => this.alert = c} onDismiss={() => this.handleAlertDismiss()}></Alert>
  The in code: this.alert.present('Title', 'Body', 'Close')
*/
export default class Alert extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
  };

  static defaultProps = {
    onDismiss: () => null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      title: '',
      body: '',
      dismissText: DEFAULT_DISMISS_TEXT,
    };
  }

  present(title, body, dismissText) {
    this.setState({
      title,
      body,
      dismissText: dismissText || DEFAULT_DISMISS_TEXT,
    });
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
    this.props.onDismiss();
  }

  render() {
    return (
      <div>
        <div className="modal-overlay" ref={el => (this.$overlay = $(el))} />
        <div className="modal" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <header>
              <h4>{this.state.title}</h4>
            </header>
            <section>
              {this.state.body}
            </section>
            <footer>
              <button type="button" className="btn btn-primary" onClick={() => this.dismiss()}>{this.state.dismissText}</button>
            </footer>
          </article>
        </div>
      </div>
    );
  }
}
